import { getCookies, getQuery, setAffiliate } from "../helpers"
import { COOKIE_NAME } from "../constants";

const cookies = getCookies();
const query = getQuery(["code", "forEmailConfirmation", "aa", "s"]);

if (query.aa) setAffiliate(query.aa);

export default {
	navigation: {
		open: false
	},
	basket: {
		items: [],
		loading: true
	},
	shop: {
		loading: true,
		creating: false,
		products: [],
		addOns: [],
		orders: [],
		shopCreationError: null
	},
	vendor: {
		loading: true,
		currentCategory: query.c || null,
		products: [],
		addOns: []
	},
	myOrders: {
		loading: true,
		list: []
	},
	session: {
		query,
		ready: !Boolean(cookies[COOKIE_NAME]),
		loading: false,
		loginError: null,
		token: cookies[COOKIE_NAME] || null,
		user: null,
		notificationState: window.Notification ? window.Notification.permission : "denied",
		needsConfirmation: false
	},
	affiliateAccount: {
		loading: true,
		introductions: []
	}
}

